import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Row, Col, Tabs, Tab, Container, Card } from "react-bootstrap";
import FounderBio from "./FounderBio.jsx";
import FounderPrayer from "./FounderPrayer.jsx";
import FoundersListView from "./FoundersListView.jsx";
import FounderContact from "./FounderContact.jsx";
import HeroSection from "../../utilities/HeroSection.jsx";
import { Skeleton } from "antd";
import axiosInstance from "../../utilities/axiosInstance.js";

let location;



function FounderDetail(props) {
  const pathParam = { ...useParams() };

  let id = pathParam.founderID;
  const { banners, isLoading, error } = props;
  console.log(banners);
  location = useLocation();

  if (!id) {
    id = props.id;
  }

  const isPageFounder = () => {
    if (location.pathname === "/founders") {
      return;
    } else {
   
      return <FoundersListView currentFounderId={id?id:props.id} />; 
    }
  };

  const [founderData, setFounderData] = useState(null);

  const url = `founders/?id=${id}`;

  const [key, setKey] = useState("name");

  const founderBanners = banners ? banners["who we are - founders"] : [];
  useEffect(() => {
    axiosInstance.get(url).then((response) => {
      setFounderData(response.data);
    });

    window.scrollTo({
      top: window.innerHeight / 3,
      left: window.innerWidth / 3,
      behavior: "smooth",
    });
  }, [url]);

  if (!founderData) {
    // Show the Skeleton UI while data is being fetched
    return (
      <>
        <HeroSection
          banners={founderBanners}
          isLoading={isLoading}
          error={error}
        />
        <Container>
          <Row xs={1} md={2} className="pt-5 px-3 text-start">
          
            <Col xs={12} md={5} className="text-center my-3">
              <Card className="py-5 px-3  text-white rounded-0">
              <Skeleton.Image style={{ width: "100%", height: "100%" }}  active />
                <Skeleton active />
              </Card>
            </Col>
            <Col md={7}>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
                tabPosition="left" // Display the Tabs vertically on the left side
              >
                <Tab
                  eventKey="name"
                  tab={<Skeleton.Button style={{ width: 200, margin: "5px" }} />}
                >
                  <Skeleton active />
                </Tab>
                <Tab
                  eventKey="prayer"
                  tab={<Skeleton.Button style={{ width: 200, margin: "5px" }} />}
                >
                  <Skeleton active />
                </Tab>
                <Tab
                  eventKey="contact"
                  tab={<Skeleton.Button style={{ width: 200, margin: "5px" }} />}
                >
                  <Skeleton active />
                </Tab>
              </Tabs>
            </Col>

            <Col md={12} className="text-center my-3">
              <Card className="py-5 px-3  text-white rounded-0">
                <Skeleton active />
              </Card>
            </Col>

            <Col xs={12} md={4} className="text-center my-3">
              <Card className="py-5 px-3  text-white rounded-0">
              <Skeleton.Image style={{ width: "100%", height: "100%" }}  active />
                <Skeleton active />
              </Card>
            </Col>
            <Col xs={12} md={4} className="text-center my-3">
              <Card className="py-5 px-3  text-white rounded-0">
              <Skeleton.Image style={{ width: "100%", height: "100%" }}  active />
                <Skeleton active />
              </Card>
            </Col>
            <Col xs={12} md={4} className="text-center my-3">
              <Card className="py-5 px-3  text-white rounded-0">
              <Skeleton.Image style={{ width: "100%", height: "100%" }}  active />
                <Skeleton active />
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }

  if (error) {
    return (
      <div
        style={{ height: 70 + `vh`, display: "flex", justifyContent: "center" }}
      >
        Something went wrong: {error}
      </div>
    );
  }

  return (
    <>
      <HeroSection
        banners={founderBanners}
        isLoading={isLoading}
        error={error}
      />
      <Container>
        {founderData &&
          founderData.map((founder) => {
            return (
              <div   key={founder.id}>
                <Row
                  key={founder.id}
                  xs={1}
                  md={2}
                  className="pt-5 px-4 text-start"
                >
                  <Col md={5} className="p-3">
                    <h4>{`${founder.name} ${founder.seniority}`}</h4>
                    <img
                      src={`${founder.image.replace("media", "static")}`}
                      alt={founder.name}
                      style={{ maxWidth: 100 + `%` }}
                      loading="lazy"
                    />
                  </Col>
                  <Col md={7}>
                    <Tabs
                      id="controlled-tab-example"
                      activeKey={key}
                      onSelect={(k) => setKey(k)}
                      className="mb-3"
                    >
                      <Tab eventKey="name" title={founder.name}>
                        <FounderBio bio={founder.bio} />
                      </Tab>
                      <Tab eventKey="prayer" title="Prayer">
                        <FounderPrayer prayer={founder.prayer} />
                      </Tab>
                      <Tab eventKey="contact" title="Contact Information">
                        <FounderContact
                          contact={founder.contact}
                          contact_text={founder.contact_text}
                        />
                      </Tab>
                    </Tabs>
                  </Col>

                  <Col md={12} className="text-center my-3 ">
                    <Card className="py-5 px-3 bg-main text-white rounded-0">
                      <Card.Text>{founder.quote}</Card.Text>
                    </Card>
                  </Col>
                </Row>
                {isPageFounder()}
              </div>
            );
          })}
      </Container>
    </>
  );
}

export default FounderDetail;
